var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-more-24px",
    transform: "translate(24 24) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M16.8,9.2h0a.967.967,0,0,0-1.4,0L12,12.6,8.6,9.2a.967.967,0,0,0-1.4,0h0a.967.967,0,0,0,0,1.4L12,15.5l4.8-4.9A.967.967,0,0,0,16.8,9.2Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp24Px);
export default __webpack_public_path__ + "static/media/arrow-up-24px.c85eea1ae1449af8256a0ebe9d282a17.svg";
export { ForwardRef as ReactComponent };